import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Alert,
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ClinicLogo from "../../Assests/cosmos  Logo.png";
import ApiServices from "../../Utils/ApiServices/ApiServices";
import SignUpAccessToken from "./SignUpAccessToken";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

const ethnicityOptions = [
  "Asian",
  "Black or African American",
  "Hispanic or Latino",
  "White",
  "Native American",
  "Pacific Islander",
  "Other",
];

const passwordRequirements = [
  { regex: /[A-Z]{2,}/, label: "At least 2 uppercase letters" },
  { regex: /[a-z]{2,}/, label: "At least 2 lowercase letters" },
  { regex: /\d{2,}/, label: "At least 2 numbers" },
  { regex: /[!@#$%^&*(),.?":{}|<>]{2,}/, label: "At least 2 symbols" },
  { regex: /^.{8,}$/, label: "At least 8 characters" },
];

const OtpInput = ({ otp, setOtp }) => {
  const boxesRef = useRef([]);

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < 5) {
      boxesRef.current[index + 1].focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.keyCode === 8 && index > 0 && otp[index] === "") {
      boxesRef.current[index - 1]?.focus();
    }
  };
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    const newOtp = pasteData.split("").map((char, index) => char);
    setOtp(newOtp);

    newOtp.forEach((value, index) => {
      boxesRef.current[index].value = value;
    });
  };

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", gap: 1 }}
      onPaste={handlePaste}
    >
      {[...Array(6)].map((_, index) => (
        <TextField
          key={index}
          inputRef={(el) => (boxesRef.current[index] = el)}
          value={otp[index] || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (!isNaN(value) && value >= 0 && value <= 9) {
              handleOtpChange(index, value);
            }
          }}
          onKeyDown={(e) => handleBackspace(e, index)}
          inputProps={{
            maxLength: 1,
            style: { textAlign: "center" },
            type: "number",
            pattern: "[0-9]*",
          }}
          sx={{
            width: 50,
            height: 50,
            "& .MuiInputBase-input": { textAlign: "center" },
            "& input[type=number]": {
              "-moz-appearance": "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
              {
                "-webkit-appearance": "none",
                margin: 0,
              },
          }}
        />
      ))}
    </Box>
  );
};

const PatientSignUp = () => {
  const [values, setValues] = useState({
    title: "",
    fname: "",
    mname: "",
    lname: "",
    street: "",
    postal_code: "",
    city: "",
    state: "",
    phone_contact: "",
    DOB: "",
    sex: "",
    race: "",
    ethnicity: "",
    email: "",
    height: "",
    weight: "",
    terms: false,
  });

  const [communicationValues, setCommunicationValues] = useState({
    token_id: "",
    allow_imm_reg_use: "UNASSIGNED",
    allow_imm_info_share: "UNASSIGNED",
    allow_health_info_ex: "UNASSIGNED",
    allow_patient_portal: "YES",
    hipaa_voice: "YES",
    hipaa_notice: "YES",
    hipaa_message: "UNASSIGNED",
    hipaa_allowsms: "YES",
    hipaa_allowemail: "YES",
    hipaa_mail: "YES",
  });
  const [createCredentialsLink, setCreateCredentialsLink] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [passwordStatus, setPasswordStatus] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
const ClosesOtpDialog =()=>{
  setOtpDialogOpen(false)
  setLoading(false)
}
  const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;
  const navigate = useNavigate();
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "postal_code" || name === "phone_contact" ||  name === "height" ||  name === "weight") {
      if (!/^\d*$/.test(value)) return;
    }

    setValues({ ...values, [name]: value });

    if (name === "postal_code") {
      validatePostalCode(value);
    }

    if (name === "phone_contact") {
      validatePhoneContact(value);
    }

    if (name === "email") {
      validateEmail(value);
    }

    // Clear error for the field being edited
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    validatePassword(newPassword, verifyPassword);
  };
  
  const handleVerifyPasswordChange = (event) => {
    const newVerifyPassword = event.target.value;
    setVerifyPassword(newVerifyPassword);
    validatePassword(password, newVerifyPassword);
  };
  
  const validatePassword = (pass, verifyPass) => {
    const errors = {};
    
    if (pass && verifyPass && pass !== verifyPass) {
      errors.password = "Passwords do not match";
    } else {
      errors.password = "";
    }
  
    setErrors((prevErrors) => ({ ...prevErrors, ...errors }));
  };

  const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    if (email && !emailRegex.test(email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Invalid email address",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  };

  const validatePostalCode = (postalCode) => {
    if (postalCode && postalCode.length !== 5) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        postal_code: "Postal code must be 5 digits",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        postal_code: "",
      }));
    }
  };

  const validatePhoneContact = (phoneContact) => {
    if (phoneContact && phoneContact.length !== 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone_contact: "Phone contact must be 10 digits",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone_contact: "",
      }));
    }
  };


  const validate = () => {
    const newErrors = {};
    Object.keys(values).forEach((key) => {
      if (
        !values[key] &&
        key !== "mname" &&
        key !== "race" &&
        key !== "ethnicity" &&
        key !== "terms"
      ) {
        newErrors[key] = "This field is required";
      }
    });
    validateEmail(values.email);

    validatePostalCode(values.postal_code);

    validatePhoneContact(values.phone_contact);

    if (!password || !verifyPassword) {
      newErrors.password = "Password and verification are required";
    } else if (password !== verifyPassword) {
      newErrors.password = "Passwords do not match";
    } else if (Object.values(passwordStatus).some((valid) => !valid)) {
      newErrors.password =
        "Please enter a password that meets the requirements";
    }

    // Terms checkbox validation
    if (!values.terms) {
      newErrors.terms = "You must agree to the Terms and Conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validate()) {
      setSnackbarMessage("Please fix the errors in the form");
      setSnackbarOpen(true);
      return;
    }
    setLoading(true)
    try {
      const verificationResponse = await ApiServices.post(
        "/apis/default/api/verifyemail",
        {
          fname: values.fname,
          mname: values.mname,
          lname: values.lname,
          email: values.email,
          DOB: values.DOB,
        }
      );
      const inputotp = verificationResponse.data.data.OTP;

      const tokenResponse = await ApiServices.get(
        `/apis/default/api/verificationtoken/${inputotp}`,
        {}
      );

      const token_id_holder = tokenResponse.data.data.token_id_holder;
      setCommunicationValues({
        ...communicationValues,
        token_id: token_id_holder,
      });

      const patientId = tokenResponse.data.data.patient_id;

      if (patientId) {
        setSnackbarMessage("This Email is Already Registered");
        setSnackbarOpen(true);
        setLoading(false)
      } else {
        try {
          const RegistrationAccessToken =
            await SignUpAccessToken.fetchAccessToken();

          const dataToRegisterPatient = {
            ...values,
            ...communicationValues,
          };

          const response = await ApiServices.post(
            "/apis/default/api/patient",
            dataToRegisterPatient,
            {
              Authorization: `Bearer ${RegistrationAccessToken}`,
            }
          );

          const patientPassLinkResponse = await ApiServices.post(
            "/apis/default/api/patientpasslink",
            {
              resetPass: false,
              email: values.email,
              token_id: response.data.data.token_id,
              pid: response.data.data.pid,
            }
          );
          const link = patientPassLinkResponse.data.data.forward;
          setCreateCredentialsLink(link);

          await ApiServices.post(
            "/apis/default/api/wallet",
            {
              initialBalance: 0,
              pid: response.data.data.pid,
            },
            {
              Authorization: `Bearer ${RegistrationAccessToken}`,
            }
          );

          await ApiServices.post(
            "/apis/default/api/patientneworresetpass",
            {
              forward: patientPassLinkResponse.data.data.forward,
              email: values.email,
              login_uname: values.email,
              pass_new: password,
              pass_new_confirm: password,
            },
            {
              Authorization: `Bearer ${RegistrationAccessToken}`,
            }
          );

          ApiServices.post(
            "/apis/default/api/intakeForms",
            {
              pid: response.data.data.pid,
            },
            {
              Authorization: `Bearer ${RegistrationAccessToken}`,
            }
          );
          setOtpDialogOpen(true);
        } catch (innerError) {
          console.error("API call error:", innerError);
          setSnackbarMessage("An error occurred while processing your request");
          setSnackbarOpen(true);
          setLoading(false)
        }
      }
    } catch (error) {
      console.error("API call error:", error);
      setSnackbarMessage("An error occurred while processing your request");
      setSnackbarOpen(true);
      setLoading(false)
    }
  };

  const handleLogin = async (e) => {
    try {
      const payload = {
        user_role: "patient",
        username: values.email,
        email: values.email,
        password: password,
        client_id: process.env.REACT_APP_CLINTID_ACS_TKN,
        scope: process.env.REACT_APP_PATIENT_SCOPES,
        grant_type: "password",
      };

      const { data, error } = await ApiServices.post(
        "/oauth2/default/token",
        payload,
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      );

      if (error) {
        // setError(
        //   error.response?.data?.error_description || "Something went wrong"
        // );
      } else {
        const encryptedUserType = CryptoJS.AES.encrypt(
          "Patient",
          secretKey
        ).toString();
        const encryptedAccessToken = CryptoJS.AES.encrypt(
          data.access_token,
          secretKey
        ).toString();
        const encryptedRefreshToken = CryptoJS.AES.encrypt(
          data.refresh_token,
          secretKey
        ).toString();

        sessionStorage.setItem("LoginUserType", encryptedUserType);
        sessionStorage.setItem("LoginUserAccessToken", encryptedAccessToken);
        sessionStorage.setItem("LoginUserRefreshToken", encryptedRefreshToken);

        const patientResponse = await ApiServices.get(
          "/apis/default/portal/patient",
          {
            Authorization: `Bearer ${data.access_token}`,
          }
        );
        const userData = patientResponse.data.data;
        const encryptedUserData = CryptoJS.AES.encrypt(
          JSON.stringify(userData),
          secretKey
        ).toString();
        sessionStorage.setItem("LoginUserDetails", encryptedUserData);

        // setpatientTokentoFetchData(data.access_token);
      }
    } catch (error) {
      console.error("Login error:", error);
      // setError("Failed to login, please check your login credentials");
    } finally {
      // setLoading(false);
    }
  };


  const handleOtpSubmit = async () => {
    try {
      const enteredOtp = otp.join("");
      const response = await ApiServices.post(
        "/apis/default/api/patientneworresetpassupdate",
        {
          forward: createCredentialsLink,
          onetime_pass: enteredOtp,
          login_uname: values.email,
          email: values.email,
        },
        { "Content-Type": "application/json" }
      );

      if (response.data.data.status === true) {
        setOtpDialogOpen(false);
        handleLogin();
        setTimeout(() => {
          setLoading(false)
          navigate("/patient/dashboard");
        }, 3000);
      } else {
        setSnackbarMessage("Please Enter Correct OTP");
        setSnackbarOpen(true);
        setOtp("");
      }
    } catch (error) {
      // setOtp("");
    }
  };

  useEffect(() => {
    if (otp && otp?.length === 6) {
      handleOtpSubmit();
    }
  }, [otp]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowVerifyPassword = () => {
    setShowVerifyPassword(!showVerifyPassword);
  };

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 5);
  const maxDateString = maxDate.toISOString().split("T")[0];

  return (
    <>
      <Box
        sx={{
          // height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)",
          minHeight: "100vh",
        }}
      >
        <Container
          component="main"
          sx={{
            // height: "100vh",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            container
            spacing={5}
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  bgcolor: "background.default",
                  borderRadius: "8px",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  p: 4,
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ textAlign: "center", mb: 4 }}>
                    <img
                      src={ClinicLogo}
                      alt="Doctor"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "150px",
                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                </Grid>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel>
                          Title<span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <Select
                          name="title"
                          value={values.title}
                          onChange={handleChange}
                          error={Boolean(errors.title)}
                        >
                          <MenuItem value="Mr">Mr</MenuItem>
                          <MenuItem value="Mrs">Mrs</MenuItem>
                          <MenuItem value="Ms">Ms</MenuItem>
                          <MenuItem value="Dr">Dr</MenuItem>
                        </Select>
                        {errors.title && (
                          <FormHelperText error>{errors.title}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="fname"
                        label={
                          <>
                            First Name
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.fname}
                        onChange={handleChange}
                        error={Boolean(errors.fname)}
                        helperText={errors.fname}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="mname"
                        label="Middle Name"
                        value={values.mname}
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="lname"
                        label={
                          <>
                            Last Name
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.lname}
                        onChange={handleChange}
                        error={Boolean(errors.lname)}
                        helperText={errors.lname}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="phone_contact"
                        label={
                          <>
                            Phone Number
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.phone_contact}
                        onChange={handleChange}
                        error={Boolean(errors.phone_contact)}
                        helperText={errors.phone_contact}
                        inputProps={{ maxLength: 10 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="email"
                        label={
                          <>
                            Email
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.email}
                        onChange={handleChange}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="street"
                        label={
                          <>
                            Street Address
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.street}
                        onChange={handleChange}
                        error={Boolean(errors.street)}
                        helperText={errors.street}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="postal_code"
                        label={
                          <>
                            Postal Code
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.postal_code}
                        onChange={handleChange}
                        error={Boolean(errors.postal_code)}
                        helperText={errors.postal_code}
                        inputProps={{ maxLength: 5 }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="city"
                        label={
                          <>
                            City
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.city}
                        onChange={handleChange}
                        error={Boolean(errors.city)}
                        helperText={errors.city}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="state"
                        label={
                          <>
                            State
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.state}
                        onChange={handleChange}
                        error={Boolean(errors.state)}
                        helperText={errors.state}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="DOB"
                        type="date"
                        label={
                          <>
                            Date of Birth
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.DOB}
                        onChange={handleChange}
                        error={Boolean(errors.DOB)}
                        helperText={errors.DOB}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: maxDateString }} // Set the max date
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel>
                          Sex<span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <Select
                          name="sex"
                          value={values.sex}
                          onChange={handleChange}
                          error={Boolean(errors.sex)}
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {errors.sex && (
                          <FormHelperText error>{errors.sex}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel>Ethnicity</InputLabel>
                        <Select
                          name="ethnicity"
                          value={values.ethnicity}
                          onChange={handleChange}
                        >
                          {ethnicityOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                       <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="height"
                        label={
                          <>
                            Height in CM
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.height}
                        onChange={handleChange}
                        error={Boolean(errors.height)}
                        helperText={errors.height}
                        inputProps={{ maxLength: 5 }}
                      />
                    </Grid>
                       <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name="weight"
                        label={
                          <>
                            Weight in KG
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={values.weight}
                        onChange={handleChange}
                        error={Boolean(errors.weight)}
                        helperText={errors.weight}
                        inputProps={{ maxLength: 5 }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
  <TextField
    fullWidth
    name="password"
    type={showPassword ? "text" : "password"}
    label={
      <>
        Password <span style={{ color: "red" }}>*</span>
      </>
    }
    value={password}
    onChange={handlePasswordChange}
    error={Boolean(errors.password)}
    helperText={errors.password}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={handleClickShowPassword} edge="end">
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</Grid>

<Grid item xs={12} sm={4}>
  <TextField
    fullWidth
    name="verifyPassword"
    type={showVerifyPassword ? "text" : "password"}
    label={
      <>
        Verify Password <span style={{ color: "red" }}>*</span>
      </>
    }
    value={verifyPassword}
    onChange={handleVerifyPasswordChange}
    error={Boolean(errors.password)}
    helperText={errors.password}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={handleClickShowVerifyPassword} edge="end">
            {showVerifyPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</Grid>


                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.terms}
                            onChange={(event) =>
                              setValues({
                                ...values,
                                terms: event.target.checked,
                              })
                            }
                            name="terms"
                            color="primary"
                          />
                        }
                        label={
                          <>
                            I agree to the{" "}
                            <a href="/terms">Terms and Conditions</a>
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                      />
                      {errors.terms && (
                        <FormHelperText error>{errors.terms}</FormHelperText>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Button variant="contained" color="primary" type="submit">
                      {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Sign Up"
                  )}
                      </Button>
                    </Grid>
                  </Grid>

                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                  >
                    <Alert onClose={handleCloseSnackbar} severity="error">
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>
                </form>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Dialog
        open={otpDialogOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setOtpDialogOpen(false);
          }
        }}
        disableEscapeKeyDown
      >
        <DialogTitle>Verify Email</DialogTitle>
        <Typography sx={{ textAlign: "center", padding: "20px" }}>
          Please enter OTP Send to <i>{values.email}</i>.
        </Typography>
        <DialogContent>
          <OtpInput otp={otp} setOtp={setOtp} />
        </DialogContent>
        <DialogActions>
          {/* <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            onClick={handleOtpSubmit}
          >
            Submit
          </Button> */}
          <Button onClick={ClosesOtpDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PatientSignUp;
